export default __webpack_public_path__ + "static/media/TPGLOGO.e3a82093.png";